import { useState } from 'react'
import { usePersistedState } from '../lib/persist.js'
import { TrendingUp, UserPlus, Megaphone } from 'lucide-react'
import RevenueStat from './statistic/RevenueStat.jsx'
import NewPatientStat from './statistic/NewPatientStat.jsx'
import CampaignStat from './statistic/CampaignStat.jsx'
import { Segmented } from './statistic/statShared.jsx'

// Each statistic is a self-contained module; a tab mounts on first visit and is
// kept mounted (inactive hidden via CSS) so switching back doesn't refetch.
const TABS = [
  { key: 'new-patient', label: 'คนไข้ใหม่', icon: UserPlus, Comp: NewPatientStat },
  { key: 'revenue', label: 'รายได้', icon: TrendingUp, Comp: RevenueStat },
  { key: 'campaign', label: 'แคมเปญ', icon: Megaphone, Comp: CampaignStat },
]

export default function Statistic() {
  const [tab, setTab] = usePersistedState('stat:tab', 'new-patient')
  const [seen, setSeen] = useState(() => new Set([tab])) // tabs ever opened → keep mounted
  const open = (key) => { setTab(key); setSeen((s) => (s.has(key) ? s : new Set(s).add(key))) }
  // default excludes สปสช (NHSO); toggle sends exclude_nhso=true|false to the APIs
  const [excludeNhso, setExcludeNhso] = usePersistedState('stat:excludeNhso', true)

  return (
    <div className="px-8 py-7 max-w-[1180px]">
      <h1 className="text-[22px] font-semibold text-slate-900 tracking-tight mb-4">สถิติ</h1>

      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        {/* statistic switcher */}
        <div className="inline-flex rounded-xl border border-slate-200 bg-slate-50 p-1">
          {TABS.map((t) => {
            const Icon = t.icon
            const on = tab === t.key
            return (
              <button key={t.key} onClick={() => open(t.key)}
                className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-[13.5px] font-medium transition ${on ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
                <Icon size={16} strokeWidth={1.9} className={on ? 'text-brand-600' : ''} />
                {t.label}
              </button>
            )
          })}
        </div>

        {/* สปสช inclusion — N/A on the campaign tab (it always includes สปสช) */}
        {tab !== 'campaign' && (
          <Segmented value={excludeNhso ? 'default' : 'all'} onChange={(v) => setExcludeNhso(v === 'default')}
            options={[{ v: 'default', label: 'ไม่รวม สปสช.' }, { v: 'all', label: 'รวม สปสช.' }]} />
        )}
      </div>

      {TABS.filter((t) => seen.has(t.key)).map((t) => (
        <div key={t.key} style={{ display: tab === t.key ? 'block' : 'none' }}>
          <t.Comp excludeNhso={excludeNhso} />
        </div>
      ))}
    </div>
  )
}
